<template>
  <defaultRecommendList/>
</template>

<script>
import defaultRecommendList from '@/components/defaultRecommendList'
export default {
  name: '404',
  metaInfo () {
    return {
      title: 'Oops！'
    }
  },
  components: {
    defaultRecommendList: defaultRecommendList
  }
}
</script>

<style lang="sass">
</style>
